module.exports = "/fonts/Objectivity-Bold.woff2";